// import router from "@/router";
import { appService } from '../../service/appService'
export const namespaced = true;

const getDefaultState = () => {
  return {

    overlay: false,

  }
}

// initial state
export const state = getDefaultState()

export const getters = {
  getOverlay(state) {
    return state.overlay;
  },

};
export const mutations = {

  SET_OVERLAY(state, payload) {
    state.overlay = payload;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};

export const actions = {
  setOverlay({ commit, state }, payload) {
    commit("SET_OVERLAY", payload);
  },

  resetState({ commit }) {
    commit('RESET_STATE')
  },
};
